<div class="row align-items-center">
  <div class="col-6">
    <h2>Artigos</h2>
  </div>
  <div class="col-6 text-end"><button class="btn btn-sm btn-success" (click)="open(content)"><i
  class="bi bi-file-earmark-plus"></i>Novo</button>
</div>
</div>
<table mat-table [dataSource]="dataSource" matSort class="mt-2">
  <ng-container matColumnDef="id">
    <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by Id">
      Id
    </th>
    <td mat-cell *matCellDef="let element">
    {{element.id}} </td>
  </ng-container>
  <ng-container matColumnDef="name">
    <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by Evento">
      Evento
    </th>
    <td mat-cell *matCellDef="let element">
    {{element.name}} </td>
  </ng-container>
  <ng-container matColumnDef="timeBefore" class="d-none d-lg-block d-xl-none">
    <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by Minutos antes"
      class="d-none d-lg-table-cell d-xl-table-cell d-xxl-table-cell">
      Minutos antes
    </th>
    <td mat-cell *matCellDef="let element" class="d-none d-lg-table-cell d-xl-table-cell d-xxl-table-cell">
    {{element.timeBefore}} </td>
  </ng-container>
  <ng-container matColumnDef="refereeType">
    <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by Tipo">
      Tipo
    </th>
    <td mat-cell *matCellDef="let element">
    {{element.refereeType == 2 ? '2 Árbitros' : '1 Árbitro'}} </td>
  </ng-container>
  <ng-container matColumnDef="actions">
    <th mat-header-cell *matHeaderCellDef></th>
    <td mat-cell *matCellDef="let row">
      <div class="btn-group" role="group" aria-label="Basic example">
        <button class="btn btn-sm" (click)="edit(content, row.id)"><i class="bi bi-pen-fill"></i></button>
        <button class="btn btn-sm" (click)="deleteItem(row.id)"><i class="bi bi-trash"></i></button>
      </div>
    </td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
  <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
</table>
<mat-paginator [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons aria-label="Selecione a página">
</mat-paginator>

<ng-template #content let-c="close" let-d="dismiss">
  <form (ngSubmit)="submitForm()" [formGroup]="formVoleiProtocol" novalidate>
    <div class="modal-header">
      <h4 class="modal-title" id="modal-basic-title">Volei Protocol</h4>
      <button type="button" class="btn-close" aria-label="Close" (click)="d('Cross click')">
      </button>
    </div>
    <div class="modal-body">
      <div class="form-group">
        <label>Nome</label>
        <input id="name" formControlName="name" type="text" class="form-control" required />
        @if (submitted && f.name.errors) {
          <small class="text-danger">
            @if (f.name.errors.required) {
              <span>Nome é obrigatório.</span>
            }
          </small>
        }
      </div>
      <div class="form-group">
        <label>Tipo</label>
        <select id="refereeType" formControlName="refereeType" class="form-select">
          <option [ngValue]="1">1 Árbitro</option>
          <option [ngValue]="2">2 Árbitros</option>
        </select>
      </div>
      <div class="form-group">
        <label>Tempo antes (em segundos)</label>
        <input id="timeBefore" formControlName="timeBefore" type="text" class="form-control" />
        @if (submitted && f.timeBefore.errors) {
          <small class="text-danger">
            @if (f.timeBefore.errors.required) {
              <span>Tempo antes é obrigatório.</span>
            }
          </small>
        }
      </div>
      <div class="form-group">
        <label>Observações</label>
        <editor [init]="{ plugins: 'lists link image table code help wordcount', height: 600 }"
          apiKey="ucebs9h257hi0y65mcmhki93g8yo59prz68898ozeadwxn04" formControlName="observations" id="observations" required>
        </editor>
        @if (submitted && f.observations.errors) {
          <small class="text-danger">
            @if (f.observations.errors.required) {
              <span> Observações é obrigatório.</span>
            }
          </small>
        }
      </div>
    </div>
    <div class="modal-footer">
      <button type="submit" class="btn btn-sm-text btn-sm btn-success">Salvar</button>
      <button type="button" class="btn btn-sm-text btn-sm btn-warning"
      (click)="c('Close click')">Cancelar</button>
      <input type="hidden" formControlName="id" name="id" id="id" />
    </div>
  </form>
</ng-template>